import { Suspense, lazy } from 'react'
import { Navigate, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'

// 桌面专用构建(VITE_DESKTOP=1):只挂核心页面,去掉依赖线上服务的页面。
// 桌面构建中 onlinePages 为 null,相关 lazy import 位于死分支,不会产出 chunk。
const DESKTOP = import.meta.env.VITE_DESKTOP === '1'

const Home = lazy(() => import('./pages/Home'))
const Ingredients = lazy(() => import('./pages/Ingredients'))
const IngredientDetail = lazy(() => import('./pages/IngredientDetail'))
const Formulas = lazy(() => import('./pages/Formulas'))
const FormulaDetail = lazy(() => import('./pages/FormulaDetail'))
const FormulaCreate = lazy(() => import('./pages/FormulaCreate'))
const Perfumes = lazy(() => import('./pages/Perfumes'))
const PerfumeDetail = lazy(() => import('./pages/PerfumeDetail'))
const TrendingPerfumes = lazy(() => import('./pages/TrendingPerfumes'))
const CommonIngredients = lazy(() => import('./pages/CommonIngredients'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Guide = lazy(() => import('./pages/Guide'))
const GuideStartup = lazy(() => import('./pages/GuideStartup'))
const ScentCategory = lazy(() => import('./pages/ScentCategory'))
// 桌面端新增:调香计算器(线上构建不挂这个路由)
const Calculator = lazy(() => import('./pages/Calculator'))

// 线上专属页面(沙龙/会员/下载/登录注册):桌面构建不打包
const onlinePages = DESKTOP
  ? null
  : {
      Membership: lazy(() => import('./pages/Membership')),
      Salon: lazy(() => import('./pages/Salon')),
      Login: lazy(() => import('./pages/Login')),
      Register: lazy(() => import('./pages/Register')),
      Download: lazy(() => import('./pages/Download')),
      Mailbox: lazy(() => import('./pages/Mailbox')),
    }

function App() {
  return (
    <>
      <Toaster position="top-center" />
      <ErrorBoundary>
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center bg-[#fcf8f2] px-6 text-center text-sm text-[#8a7060]">
              香研社正在整理这一页的气味资料...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="home" element={<Home />} />
              <Route path="ingredients" element={<CommonIngredients />} />
              <Route path="ingredients/all" element={<Ingredients />} />
              <Route path="ingredients/:id" element={<IngredientDetail />} />
              <Route path="formulas" element={<Formulas />} />
              <Route path="formulas/new" element={<FormulaCreate />} />
              <Route path="formulas/:id" element={<FormulaDetail />} />
              <Route path="perfumes" element={<Perfumes />} />
              <Route path="perfumes/trending" element={<TrendingPerfumes />} />
              <Route path="perfumes/common" element={<CommonIngredients />} />
              <Route path="perfumes/:id" element={<PerfumeDetail />} />
              {DESKTOP && <Route path="calculator" element={<Calculator />} />}
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="guide" element={<Guide />} />
              <Route path="teaching" element={<Guide />} />
              <Route path="startup" element={<GuideStartup />} />
              <Route path="scents/:category" element={<ScentCategory />} />
              {onlinePages && (
                <>
                  <Route path="ai" element={<Navigate to="/home" replace />} />
                  <Route path="membership" element={<onlinePages.Membership />} />
                  <Route path="download" element={<onlinePages.Download />} />
                </>
              )}
            </Route>
            {onlinePages && (
              <>
                <Route path="/salon" element={<onlinePages.Salon />} />
                <Route path="/salon/kiosk" element={<Navigate to="/salon" replace />} />
                <Route path="/login" element={<onlinePages.Login />} />
                <Route path="/register" element={<onlinePages.Register />} />
                <Route path="/mailbox" element={<onlinePages.Mailbox />} />
              </>
            )}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </>
  )
}

export default App
